import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { landingFor } from "@/config/roles";
import { LoginPage } from "@/features/auth/components/login-page";
import { session } from "@/lib/auth";

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    const { user } = session.get();
    if (session.isAuthenticated() && user) {
      throw redirect({ to: landingFor(user.role, search.redirect) });
    }
  },
  component: LoginPage,
});
